export default "__VITE_ASSET__ky85W95o__"